import React, { useState } from 'react';
import {
  Typography,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from '@mui/material';

const UnlockIccDialog = ({ open, onClose, onContinue, message }) => {
  const [reason, setReason] = useState('');

  const handleContinue = () => {
    if (onContinue) {
      onContinue(reason);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth='xs'>
      <DialogTitle>Confirmación</DialogTitle>
      <DialogContent>
        <Typography>Asegúrate de revisar el estado de la línea en Qvantel.</Typography>
        <TextField
          label='Motivo del desbloqueo'
          variant='outlined'
          fullWidth
          margin='normal'
          value={reason}
          onChange={(e) => setReason(e.target.value)}
        />
        {message && (
          <Typography color={message.includes('exitoso') ? 'green' : 'red'} marginTop={2}>
            {message}
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button variant='contained' color='primary' onClick={handleContinue}>
          Continuar
        </Button>
        <Button variant='outlined' color='secondary' onClick={onClose}>
          Cancelar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UnlockIccDialog;
